import { render, staticRenderFns } from "./Greatful.vue?vue&type=template&id=45b39dfe&scoped=true&"
import script from "./Greatful.vue?vue&type=script&lang=ts&"
export * from "./Greatful.vue?vue&type=script&lang=ts&"
import style0 from "./Greatful.vue?vue&type=style&index=0&id=45b39dfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b39dfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
